<template>
  <div class="loader-row">
    <img src="/static/assets/images/loading.gif" />
  </div>
</template>

<script>
  export default {
    name: 'Loading',
    data: function () {
      return {
        isLoading: false
      }
    },
    created() {

     
    }
  }



</script>



// WEBPACK FOOTER //
// src/components/Loading.vue